import { getColorFromAppState } from '../../../utils/Helper'
import tw, { styled } from 'twin.macro'

export const CardRoot = styled.div<SCWithColorProps>`
  ${tw`py-16 px-10 rounded-xl`}
  background-color: ${getColorFromAppState};
`